<template>
<validation-observer ref="observer" v-slot="{ passes }">
    <b-form @submit.prevent="passes(onFormSubmit)" novalidate>
    <b-overlay 
        :show="$store.getters['loading/isLoading']('consultation')"
        rounded="sm"
        variant="light"
        spinner-variant="primary"
        :opacity="0.80"
        blur="2px">
        <b-form-group :disabled="isLocked">
            <b-form-group>
                <b-form-select size="sm" id="reason_type" v-model="form.reason_type" :disabled="isLocked">
                    <b-form-select-option disabled :value="null">* Select Reason</b-form-select-option>
                    <b-form-select-option v-for="reason in reasonTypes" :key="reason.name" :value="reason.id">{{ reason.name }}</b-form-select-option>
                </b-form-select>
            </b-form-group>
            <validation-provider vid="reason" v-slot="{ errors }">
            <b-form-group
                :invalid-feedback="errors[0]"
                :state="errors[0] ? false : null">
                <b-form-input size="sm" id="reason" ref="rfe" v-model="form.reason" :disabled="isLocked" placeholder="Reason for encounter" />
            </b-form-group>
            </validation-provider>

            <b-form-group>
                <b-form-select size="sm" id="insurance" v-model="form.insurance" plain :disabled="isLocked">
                    <b-form-select-option :value="null">Select Insurance</b-form-select-option>
                    <b-form-select-option v-for="insurance in insurances" :key="insurance.id" :value="insurance.id" :disabled="!insurance.is_active">
                        {{ insurance.name }} {{ !insurance.is_active ? '(Inactive)' : '(Active)' }}
                    </b-form-select-option>
                </b-form-select>
            </b-form-group>

        </b-form-group>
    </b-overlay>
    <template v-if="checkUserPermission('consultation', 'can_change')">
        <b-button class="mr-1" :disabled="isLocked" type="submit" variant="success"><i class="fa-regular fa-circle-dot"></i> Submit</b-button>
        <b-button v-if="isLocked" type="button" variant="warning" @click="isLocked = false"><i class="fa-solid fa-unlock"></i> Unlock</b-button>
        <b-button v-if="!isLocked && !isDirty && !hasErrors" type="button" variant="outline-primary" @click="isLocked = true"><i class="fa-solid fa fa-lock"></i> Lock</b-button>
        <b-button v-if="isDirty || hasErrors" type="button" variant="danger" @click="reset"><i class="fa-solid fa-ban"></i> Reset</b-button>
    </template>
</b-form>
</validation-observer>	
</template>
<script>
import FormExtension from "@/core/components/FormExtension"
import { mapGetters, mapState, mapActions } from "vuex"

export default FormExtension.extend({
    name: 'consultation-form',
    data() {
        return {
            form: new Form({
                reason_type: null,
                reason: null,
                is_walkin: false,
                insurance: null,
                consistency_token: null,
            }),
            insurances: [],
        }
    },
    computed: {
        ...mapGetters('schedule', ['getCurrentConsultation']),
        consultation() {
            return this.getCurrentConsultation()
        },
        ...mapGetters('planning', ['getReasonTypes']),
        reasonTypes() {
            return this.getReasonTypes()
        }
    },
    watch: {
        consultation: {
            immediate: true,
            handler(val) {
                this.form.withData(val)
            }
        },
        form: {
            deep: true,
            handler(val) {
                this.isDirty = this.form.dirty()

                if (this.isDirty) {
                    this.dirty()
                }else{
                    this.validated()
                }
            }
        }
    },
    methods: {
        ...mapActions("planning", ["getConsultReasonTypes"]),
        ...mapActions('insurances', ['getInsurancesForCurrentPatient']),
        ...mapActions('schedule', ['setPatientHasArrived', 'updateConsultationInformation']),
        async loadForPatient(patient) {
            this.insurances = await this.getInsurancesForCurrentPatient()
        },
        onFormSubmit() {
            this.updateConsultationInformation(this.form.data()).then(() => {
                this.notify("Consultation updated", "Consultation was updated successfully")
                this.isLocked = true
                this.$emit('saved')
            })
            .catch(errors => {
                this.$refs.observer?.setErrors(errors?.response?.data)
                this.hasErrors = true
            })
        },
        async loadForPatient(patient) {
            this.insurances = await this.getInsurancesForCurrentPatient()
        },
        reset() {
            this.form.reset()
            this.$nextTick(() => {
                this.$refs.observer?.reset()
                this.hasErrors = false
                this.isLocked = true
                this.validated()
            })
        }
    },
    async mounted() {
        await this.getConsultReasonTypes()
    }
})
</script>